(function (scope) {
  "use strict";

  /**
   * @constructor
   * @param {sculpteo.PrintBatchControlView} controller
   * @param {Viewer} viewer
   * @param {Design} design
   */

  var PrintBatchControlView = (scope.PrintBatchControlView = function (
    controller,
    viewer,
    design
  ) {
    this.controller = controller;
    this.design = design;
    this.viewerUI = viewer.viewerUI;
    this.viewer = viewer.viewerUI.viewer;
    this.$el = $("#batch-control-buttons");

    this.batchThreshold = 20;
    this.previousQuantity = 1;
    this.previousBatchControlAvailable = false;

    this.$el.on(
      "click",
      ".tool-back-default",
      this.backToDefaultView.bind(this)
    );
    this.$el.on(
      "click",
      ".tool-back-part-orientation",
      this.backToPartOrientationView.bind(this)
    );

    this.is_view_enabled = false;
  });

  /**
   * Back to default view
   * @private
   */
  PrintBatchControlView.prototype.backToDefaultView = function (e) {
    this.controller.switchTool(sculpteo.PrintToolsView.TOOLS.DASHBOARD);
  };

  /**
   * Back to orientation view
   * @private
   */
  PrintBatchControlView.prototype.backToPartOrientationView = function () {
    this.controller.switchTool(sculpteo.PrintToolsView.TOOLS.ORIENTATION);
  };

  /**
   * hide/show the button to go in part orientation
   * @private
   */
  PrintBatchControlView.prototype.togglePartOrientationViewButton = function (
    enabled
  ) {
    if (enabled) {
      $(".tool-back-part-orientation", this.$el).show();
    } else {
      $(".tool-back-part-orientation", this.$el).hide();
    }
  };

  /**
   * enable the batch control button
   * @public
   */
  PrintBatchControlView.prototype.enabled = function () {
    this.$el.show();

    this.viewerUI.series.view = false;
    this.viewerUI.toggle_series_view(true);

    this.is_view_enabled = true;
  };

  /**
   * disable the batch control button
   * @public
   */
  PrintBatchControlView.prototype.disabled = function () {
    this.viewerUI.toggle_series_view(false);
    this.$el.hide();

    this.is_view_enabled = false;
  };

  /**
   * Update batch control view if it is enabled
   * @public
   */
  PrintBatchControlView.prototype.updateView = function () {
    if (this.is_view_enabled) {
      this.viewerUI.series.view = false;
      this.viewerUI.toggle_series_view(true);
    }
  };

  /**
   * Check batch control availability on quantity/material/size update and toggle it automatically.
   *
   * @todo display batch height
   * @todo refresh only if availability or quantity differs
   * @todo move to controller.
   */
  PrintBatchControlView.prototype.updateBatchControl = function () {
    var deferred = $.Deferred();

    var materialsBatchResponse =
      this.controller.materials.isBatchControlAvailableForDesign(this.design);
    var batchControlAvailable = materialsBatchResponse.available;
    var batchControlErrorID = materialsBatchResponse.error_id;

    // if (this.design.series.enabled != batchControlAvailable) {
    // 	if(batchControlAvailable){
    // 		this.controller.notify('info',sculpteo.INFO.BATCH_QUALIFIES, true);
    // 	}
    // 	else{
    // 		var id = sculpteo.WARNING.BATCH_NO_QUALIFIES;
    // 		if(batchControlErrorID == "design_scale_too_large"){
    // 			id = sculpteo.WARNING.BATCH_NO_QUALIFIES_SCALE_TOO_LARGE;
    // 		}
    // 		this.controller.notify('warn',id, false);
    // 	}
    // }

    this.controller.views.tools.toggle(
      sculpteo.PrintToolsView.TOOLS.BATCH_CONTROL,
      batchControlAvailable
    );

    this.controller.views.tools.setEnabled(
      sculpteo.PrintToolsView.TOOLS.BATCH_CONTROL,
      batchControlAvailable
    );

    this.design.series.enabled = batchControlAvailable;

    //toggle batch mode for orientation
    this.controller.views.partOrientation.toggleBatchMode(
      batchControlAvailable
    );

    if (
      (this.design.order.quantity < this.batchThreshold &&
        this.previousQuantity >= this.batchThreshold) ||
      (this.design.order.quantity >= this.batchThreshold &&
        this.previousQuantity != this.design.order.quantity) ||
      batchControlAvailable != this.previousBatchControlAvailable
    ) {
      // Automatically updates batch control status
      this.design
        .update_print_op(
          undefined,
          undefined,
          undefined,
          batchControlAvailable ? this.design.order.quantity : 0,
          undefined,
          this.design.material,
          this.design.finish,
          this.design.painting
        )
        .then(
          function () {
            deferred.resolve();
            this.viewerUI.refreshModel({
              update_geometry: true,
              force_refresh: true,
            });

            if (this.is_view_enabled) {
              this.viewerUI.series.view = false;
              this.viewerUI.toggle_series_view(true);
            }
          }.bind(this)
        )
        .fail(
          function () {
            // When the print op isn't changed, it's considered as fail.
            deferred.resolve();
          }.bind(this)
        );
    } else {
      deferred.resolve();
    }

    this.previousQuantity = this.design.order.quantity;

    this.previousBatchControlAvailable = batchControlAvailable;

    return deferred;
  };
})((window.sculpteo = window.sculpteo || {}));
